import React, { useState } from "react";
import axios from "axios";
import { showErrorToast, showSuccessToast } from "../../utils/toaster";
import { baseurl } from "../../config/url";

function Verifyotp({ email, closeLoginDialog, setshowotpcomponent }) {
  let usercredentials = JSON.parse(
    localStorage.getItem("usercredentials") || "{}"
  );
  email = email || usercredentials.email;
  const [otp, setOtp] = useState(""); // To store OTP entered by the user
  const [errorMessage, setErrorMessage] = useState(""); // To display error message if OTP is invalid

  const handleChange = (event) => {
    setOtp(event.target.value);
  };
  const [cooldown, setCooldown] = useState(0);
  const [loadingResend, setLoadingResend] = useState(false);



  const handleSubmit = async () => {
    if (otp === "") {
      setErrorMessage("OTP cannot be empty.");
      return;
    }
    try {
      const user = await axios.post(
        `${baseurl}/api/user/verify-otp`,
        { email, otp }
      );
      setshowotpcomponent(false);
      closeLoginDialog();
      showSuccessToast("OTP verified successfully!");
    } catch (error) {
      showErrorToast(error.response?.data.message || "OTP verification failed");
    }
    setErrorMessage("");
  };

  const handleResendOtp = async () => {
    if (cooldown > 0) return;

    setLoadingResend(true);
    setCooldown(30); // Start cooldown immediately

    try {
      await axios.post(`${baseurl}/api/user/send-email`, { email });
      showSuccessToast("OTP sent to your email.");

      // Start cooldown
      setCooldown(30);
      const interval = setInterval(() => {
        setCooldown((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } catch (error) {
      console.error("Resend OTP Error:", error.response?.data || error.message);

      // Only show a message if it's something the user can act on
      if (error.response?.status === 429) {
        showErrorToast("Please wait before requesting another OTP.");
      }
      // Else: no message shown for 500/internal issues
    } finally {
    setLoadingResend(false); // ✅ Ensure this always runs
  }
  };


  return (
    <section className="p-5 max-w-md mx-auto">
      <h3 className="text-xl font-semibold text-center text-indigo-600 mb-4">
        Verify OTP
      </h3>
      <p className="text-center text-gray-600 mb-2">
        Please enter the OTP sent to your email address:
      </p>
      <p className="text-center font-bold text-black mb-6">{email}</p>

      <div className="mb-4">
        <input
          type="text"
          value={otp}
          onChange={handleChange}
          placeholder="Enter OTP"
          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
        {errorMessage && (
          <p className="text-red-600 text-sm text-center mt-2">
            {errorMessage}
          </p>
        )}
      </div>

      <div className="flex flex-col gap-4">
        <button
          onClick={handleSubmit}
          className="w-full bg-indigo-600 text-white py-2 rounded-md font-semibold hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
        >
          Verify OTP
        </button>

        <p className="text-sm text-center text-gray-600">
          Didn’t receive the OTP?{" "}
          <button
            onClick={handleResendOtp}
            disabled={cooldown > 0 || loadingResend}
            className={`text-indigo-600 font-medium focus:outline-none ${cooldown > 0 || loadingResend
                ? "opacity-50 cursor-not-allowed"
                : "hover:underline"
              }`}
          >
            {loadingResend
              ? "Resending..."
              : cooldown > 0
                ? `Resend in ${cooldown}s`
                : "Resend"}
          </button>


        </p>
      </div>
    </section>
  );
}

export default Verifyotp;
